module.exports = __webpack_public_path__ + "9873885f352c415ad25c32ecf69e5cd3.svg";